'use strict';

const $ = window.jQuery;

function getCenter (element) {
    let bodyRect = document.body.getBoundingClientRect();
    const { left, top, width, height } = element.getBoundingClientRect();
    return { x: (left + width / 2) - bodyRect.left, y: (top + height / 2) - bodyRect.top };
}

export default class OrientationTable {
    constructor() {
        if ($('#orientation-table').length <= 0) {
            return;
        }

        const $body = $('body');
        const orientationTable = document.getElementById('orientationTable');
        const wheel = document.getElementById('wheel');
        const wheelCenter = getCenter(wheel);
        const $rotateItems = $('.ot-rotate');

        orientationTable.addEventListener('mousemove', wheelRotate);

        function wheelRotate (e) {
            const angle = Math.atan2(e.pageY - wheelCenter.y, e.pageX - wheelCenter.x);
            wheel.style.transform = `rotate(${angle}rad)`;
        }

        // Auto-rotate wheel
        let rotateVal = 0;
        const svgWheel = document.getElementById('svgWheel');
        const st = window.getComputedStyle(svgWheel, null);

        window.setInterval(function () {
            const tr = st.getPropertyValue('transform');
            if (tr !== 'none') {
                let values = tr.split('(')[1].split(')')[0].split(',');
                let a = values[0];
                let b = values[1];
                let angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));

                rotateVal = angle;
            }
        }, 10);

        // NiceScroll
        $('.ot-popin-block__scrollr').niceScroll({
            cursorcolor: '#333',
            cursorborder: '0',
            cursorborderradius: '0',
            cursoropacitymin: 0.2
        });

        // Click events
        const $clickableBlock = $('.ot-click-needed');

        $clickableBlock.on('click', function () {
            const clickedID = $(this).attr('id');

            if (this.tagName === 'ARTICLE') {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(this).offset().top - $('#header').height() - 30
                }, 1000);
            }

            $body.addClass('noscroll');

            orientationTable.removeEventListener('mousemove', wheelRotate);
            wheel.style.transform = 'rotate(-90deg)';

            $clickableBlock.removeClass('is-active low-opacity');
            $('#back').addClass('low-opacity');
            $clickableBlock.not(this).addClass('low-opacity');
            $(this).addClass('is-active');

            $('.ot-popin-block').removeClass('is-active');
            $(`[data-id=${clickedID}]`).addClass('is-active');
            $('.ot-popin-block__scrollr').getNiceScroll(0).resize();

            switch (clickedID) {
            case 'disks':
                $rotateItems.css({
                    'transform': `rotate(${35 - rotateVal}deg)`
                });
                break;
            case 'user':
                $rotateItems.css({
                    'transform': `rotate(${80 - rotateVal}deg)`
                });
                break;
            case 'share':
                $rotateItems.css({
                    'transform': `rotate(${146 - rotateVal}deg)`
                });
                break;
            case 'library':
                $rotateItems.css({
                    'transform': `rotate(${205 - rotateVal}deg)`
                });
                break;
            case 'cloud':
                $rotateItems.css({
                    'transform': `rotate(${268 - rotateVal}deg)`
                });
                break;
            case 'exchange':
                $rotateItems.css({
                    'transform': `rotate(${328 - rotateVal}deg)`
                });
                break;
            }

            svgWheel.classList.add('is-animation-paused');
        });

        $('.ot-popin-block__close').on('click', function () {
            $body.removeClass('noscroll');
            $('#back').removeClass('low-opacity');
            $clickableBlock.removeClass('is-active low-opacity');
            $(this).parent().removeClass('is-active');
            wheel.style.transform = 'rotate(0deg)';
            orientationTable.addEventListener('mousemove', wheelRotate);
            svgWheel.classList.remove('is-animation-paused');
            $(this).siblings('.ot-popin-block__scrollr').getNiceScroll(0).doScrollTop(0, 0);
        });
    }
}
